<template>
  <div class="subpage main_area" style="position: relative">
    <div class="player_profile player_profiledetails layout">
      <div class="tips_block">温馨提示：信息填写立即绑定。一经绑定不可随意修改。如需修改资料，请联系 24 小时在线客服为您服务。</div>
      <form class="bankcards_add_form" id="bankcards_add_form">
        <input type="hidden" name="player_update" value="1" id="player_update" />
        <div class="block_content">
          <label class="textbox_content">
            <input type="text" v-model="cardInfo.bank_owner" placeholder="中文真实姓名" name="account_name" id="account_name" class="fn binput" />
            <div class="input_title"></div>
            <div class="error_msg account_name_error"></div>
          </label>
        </div>
        <div class="block_content">
          <label class="textbox_content">
            <select name="" v-model="cardInfo.bank" id="" class="fn binput">
              <option :value="null" disabled selected>请选择银行</option>
              <option :value="item.bank_name" v-for="(item, index) in banklist" :key="index">{{ item.bank_name }}</option>
            </select>
            <div class="input_title"></div>
            <div class="error_msg mobile_number_error"></div>
          </label>
        </div>

        <div class="block_content">
          <label class="textbox_content branchname_hide">
            <input type="text" placeholder="分行名称" name="branch_name" id="branch_name" v-model="cardInfo.bank_address" class="other_bank_name ireset" />
            <div class="input_title"></div>
            <div class="error_msg branch_name_error"></div>
          </label>
        </div>
        <div class="block_content">
          <label class="textbox_content">
            <input type="text" placeholder="银行卡号" v-model="cardInfo.bank_no" oninput="value=value.replace(/[^0-9]/g,'')" name="account_number" id="account_number" class="digit ireset binput" maxlength="19" />
            <div class="input_title"></div>
            <div class="error_msg account_number_error"></div>
          </label>
        </div>
        <div class="block_content">
          <label class="textbox_content">
            <input type="password" placeholder="支付密码" v-model="cardInfo.pay_pass" name="account_number" id="account_number" class="digit ireset binput" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')"
 />
            <div class="input_title"></div>
            <div class="error_msg account_number_error"></div>
          </label>
        </div>
        <div class="block_content dbreset">
          <input type="hidden" name="default_bank" value="1" />
        </div>
        <div class="block_content" @click="bindCard">
              <label class="textbox_content">
                      <div class="btn_major add_bank_btn" >添加银行卡</div>

          </label>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data() {
    return { banklist: [], cardInfo: { bank: null } };
  },
  created() {
    let that = this;
    that.baseURL = sessionStorage.getItem('baseURL') || '';
    console.log(sessionStorage.getItem('baseURL'));
    that.getBanklist();
  },
  methods: {
    getBanklist() {
      let that = this;
      that.$apiFun.post('/api/banklist', {}).then(res => {
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.banklist = res.data;
        }
      });
    },
    bindCard() {
      let that = this;
      if (!that.cardInfo.bank_owner) {
        that.$parent.showTost(0, '请输入姓名');
        return;
      }
      if (!that.cardInfo.bank) {
        that.$parent.showTost(0, '请输入银行');
        return;
      }
      if (!that.cardInfo.bank_address) {
        that.$parent.showTost(0, '请输入开户行地址');
        return;
      }
      if (!that.cardInfo.bank_no) {
        that.$parent.showTost(0, '请输入银行卡号');
        return;
      }
      if (!that.cardInfo.pay_pass) {
        that.$parent.showTost(0, '请输入支付密码');
        return;
      }
      if (that.cardInfo.bank_no.length < 8) {
        that.$parent.showTost(0, '请输入正确的卡号长度');
        return;
      }
      if (that.cardInfo.pay_pass.length < 6 || that.cardInfo.pay_pass.length > 18) {
        that.$parent.showTost(0, '请输入支付密码长度');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', that.cardInfo)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '绑定成功');
            this.$router.back();
          }

          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mode/addBankCard.vue